import styled from 'styled-components'
import { breakpoints } from '../../../constants'
import Browser from '../../../services/Browser'

export const StyledDiv = styled.div`
	display: ${Browser.isIE() ? 'flex' : 'grid'};
	flex-direction: column;
	grid-gap: 4rem 15px;
	grid-auto-flow: row sparse;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		grid-template: repeat(7, auto) / repeat(3, 1fr);

		.postalCode {
			order: 1;
		}

		.static-information {
			order: 2;
			grid-column: 2 / 4;
		}

		.streetAddress {
			order: 3;
			grid-row: 2 / 3;
			grid-column: 1 / -1;
		}

		.number {
			order: 4;
			grid-row: 3 / 4;
			grid-column: 1 / 2;
		}

		.addressComplement {
			order: 5;
			grid-row: 4 / 5;
			grid-column: 1 / -1;
		}

		.neighborhood {
			order: 6;
			grid-row: 5 / 6;
			grid-column: 1 / -1;
		}

		.city {
			order: 7;
			grid-row: 6 / 7;
			grid-column: 1 / -1;
		}

		.state {
			order: 8;
			grid-row: 7 / 8;
			grid-column: 1 / 3;
		}
	}

	& > * {
		margin-bottom: ${Browser.isIE() ? '4rem' : null};
	}
`
